const constants = {
  EXERCISE_RUN_SHOW_VARIABLES: 'EXERCISE_RUN_SHOW_VARIABLES',

  EXERCISE_VARIABLES_CHANGE_VARIABLE_INPUT: 'EXERCISE_VARIABLES_CHANGE_VARIABLE_INPUT',
  EXERCISE_VARIABLES_COPY_VARIABLES: 'EXERCISE_VARIABLES_COPY_VARIABLES',
  EXERCISE_VARIABLES_CHANGE_NEW_VARIABLE_KEY: 'EXERCISE_VARIABLES_CHANGE_NEW_VARIABLE_KEY',
  EXERCISE_VARIABLES_CHANGE_NEW_VARIABLE_VALUE: 'EXERCISE_VARIABLES_CHANGE_NEW_VARIABLE_VALUE',
  EXERCISE_VARIABLES_LOADING_START: 'EXERCISE_VARIABLES_LOADING_START',
  EXERCISE_VARIABLES_LOADING_END: 'EXERCISE_VARIABLES_LOADING_END',

  EXERCISE_RUN_UNIT_SELECT: 'EXERCISE_RUN_UNIT_SELECT',
  EXERCISE_RUN_UNITS_SELECT: 'EXERCISE_RUN_UNITS_SELECT',
  EXERCISE_RUN_LOCATION_SELECT: 'EXERCISE_RUN_LOCATION_SELECT',
  EXERCISE_RUN_LOCATION_PREVIEW_SELECT: 'EXERCISE_RUN_LOCATION_PREVIEW_SELECT',

  CBOX_CHANGE_INPUT: 'CBOX_CHANGE_INPUT',
  CBOX_SELECT_USER: 'CBOX_SELECT_USER',
  CBOX_DESELECT_USER: 'CBOX_DESELECT_USER',
  CBOX_DESELECT_ALL_USER: 'CBOX_DESELECT_ALL_USER',
  CBOX_CLEAR_INPUT: 'CBOX_CLEAR_INPUT',
};

export default constants;
